module.exports = __webpack_public_path__ + "img/start.14732f7f.svg";